// ANT DESIGN IMPORT
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DislikeOutlined,
  DownloadOutlined,
  HolderOutlined,
  InfoCircleOutlined,
  SafetyOutlined,
  SendOutlined,
  SettingOutlined,
  SyncOutlined,
  UploadOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import {
  Card,
  Col,
  Flex,
  Row,
  Space,
  Statistic,
  Tag,
  Tooltip,
  Typography,
} from "antd";

//CURRENT ACCOUNT ANTD ICONS IMPORT

//PROJECT IMPORT
import Lock01 from "@untitled-ui/icons-react/build/esm/Lock01";

import { BOM } from "../../services/definedMethod";

const { Text, Title, Paragraph } = Typography;

export const AccountFacility = (props) => {
  const {
    status,
    prodDetail,
    isProduct = false,
    name,
    id,
    nubanNumber,
    amount,
    interest,
    interestPerAnnum,
    maturityDate,
    currencyCode,
    aggregateBalance,
  } = props;
  const formatCurrency = (value, currencyCode) => {
    const safeValue = Number(value ?? 0);

    if (!currencyCode) {
      return safeValue.toLocaleString();
    }

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currencyCode.trim().toUpperCase(),
      }).format(safeValue);
    } catch {
      return safeValue.toLocaleString();
    }
  };
  return (
    <>
      <Row
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 20,
          marginTop: 24,
          marginBottom: 24,
        }}
      >
        {!isProduct && (
          <Card
            style={{
              backgroundColor: "#FDF4FF",
              borderRadius: "12px",
              height: "164px",
            }}
            bordered={false}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <Space align="center">
                  <Text
                    type="secondary"
                    color="#475467"
                    style={{ fontWeight: 500 }}
                  >
                    Current Balance
                  </Text>
                </Space>
                <Title
                  level={2}
                  style={{ marginBottom: 0, marginTop: 0, fontWeight: 600 }}
                >
                  {formatCurrency(amount, currencyCode)}
                </Title>
              </div>
              {aggregateBalance !== undefined && (
                <Row style={{ gap: 10, alignItems: "center", marginTop: 6 }}>
                  <Text
                    type="secondary"
                    color="#475467"
                    style={{ fontWeight: 500 }}
                  >
                    Agg. Balance:
                  </Text>
                  <Text style={{ fontWeight: 600 }}>
                    {formatCurrency(aggregateBalance, currencyCode)}
                  </Text>
                </Row>
              )}
            </Space>
          </Card>
        )}

        <Card
          style={{
            flex: 1,
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "12px",
            gridColumn: isProduct ? "2" : "auto",
          }}
        >
          <Flex justify="space-between">
            <Space direction="vertical" size="middle">
              <div>
                <Text type="secondary">
                  {isProduct ? "Product Name" : "Agent Name"}
                </Text>
                <Title level={5} style={{ marginTop: 4, marginBottom: 0 }}>
                  {name}
                </Title>
              </div>

              <div>
                <Text type="secondary">
                  {isProduct ? "Product Code" : "Account Number"}
                </Text>
                <Title level={5} style={{ marginTop: 4, marginBottom: 0 }}>
                  {nubanNumber}
                </Title>
              </div>
            </Space>

            <Flex gap="large" justify="end">
              <Col>
                {status
                  ? handleFlgStatus(
                      status,
                      {
                        padding: "2px 12px",
                        borderRadius: "16px",
                        fontSize: "12px",
                        fontWeight: 500,
                        display: "inline-block",
                        textTransform: "capitalize",
                      },
                      false,
                      prodDetail,
                    )
                  : "-"}
              </Col>
            </Flex>
          </Flex>
        </Card>
      </Row>
    </>
  );
};

export const handleFlgStatus = (
  status,
  style = {},
  isListing = false,
  otherParams = {},
) => {
  switch (status.toLowerCase()) {
    case "approved":
      return (
        <Tag
          icon={<SafetyOutlined />}
          color={`${isListing ? "purple" : "#EEF4FF"}`}
          style={{ color: "#3538CD", border: "1px solid #C7D7FE", ...style }}
        >
          {status}
        </Tag>
      );
    case "matured":
      return (
        <Tag
          color={`${isListing ? "purple" : "#F9FAFB"}`}
          style={{ color: "#344054", border: "1px solid #EAECF0", ...style }}
        >
          {status}
        </Tag>
      );
    case "pending":
      return (
        <Tag
          icon={<SyncOutlined spin />}
          color={`${isListing ? "orange" : "#F4F3FF"}`}
          style={{
            color: "#5925DC",
            border: "1px solid #D9D6FE",
            ...style,
          }}
        >
          {status}
        </Tag>
      );
    case "disabled":
      return (
        <Tag
          icon={<DislikeOutlined />}
          color={`${isListing ? "grey" : "#F9FAFB"}`}
          style={{ color: "#344054", border: "1px solid #EAECF0", ...style }}
        >
          {status}
        </Tag>
      );
    case "active" || "success":
      if (otherParams?.inArrears) {
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {"Active in Bad Standing"}
          </Tag>
        );
      } else {
        return (
          <Tag
            // icon={<CheckCircleOutlined />}
            color={"#067647"}
            style={{
              border: "1px solid #ABEFC6",
              backgroundColor: "#ECFDF3",
              color: "#067647",
              padding: "2px 12px",
              borderRadius: "16px",
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              textTransform: "capitalize",
            }}
          >
            {status}
          </Tag>
        );
      }
    case "rejected":
    case "premature closed":
    case "closed":
    case "closed early":
      return (
        <Tag
          icon={<CloseCircleOutlined />}
          color={`${isListing ? "red" : "#FEF3F2"}`}
          style={{
            color: "#B42318",
            border: "1px solid #FECDCA",
            ...style,
          }}
        >
          {status}
        </Tag>
      );
    default:
      return (
        <Tag
          icon={<ClockCircleOutlined />}
          color={`${isListing ? "warning" : "#FFEB86"}`}
          style={{ color: "black", ...style }}
        >
          {BOM.SubstringFormat(status, 21)}
        </Tag>
      );
  }
};
export const handleFlgSubStatus = (
  subStatus,
  style = {},
  isListing = false,
  otherParams = {},
) => {
  const getNameFromValue = (value) => {
    const mapping = {
      block: "Blocked",
      blockcredit: "Credit Blocked",
      blockdebit: "Debit Blocked",
    };
    return mapping[value] || value;
  };
  const statusName = getNameFromValue(subStatus?.toLowerCase());
  if (subStatus?.toLowerCase() === "none") {
    return "--";
  }
  return (
    <Tag
      icon={<CloseCircleOutlined />}
      color={`${isListing ? "red" : "#FEF3F2"}`}
      style={{
        color: "#B42318",
        border: "1px solid #FECDCA",
        ...style,
      }}
    >
      {statusName}
    </Tag>
  );
};
export const handleWalletAccountActionButtons = (contractDetail) => {
  const status = contractDetail?.savingsAccountData?.status?.value;

  switch (status?.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve",
          key: "1",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("APPROVE_WALLETACCOUNT"),
          icon: <SafetyOutlined />,
        },
        // {
        //   label: "Add Sub Wallet",
        //   key: "2",
        //   route: "/wallet-account-action",
        //   disabled: !BOM.HasPermission("ADD_SUBWALLET_WALLETACCOUNT"),
        //   icon: <WalletOutlined />,
        // },
        {
          label: "Apply Charge",
          key: "2",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("APPLY_CHARGES_WALLETACCOUNT"),
          icon: <WalletOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Activate",
          key: "1",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_WALLETACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        // {
        //   label: "Add Sub Wallet",
        //   key: "2",
        //   route: "/wallet-account-action",
        //   disabled: !BOM.HasPermission("ADD_SUBWALLET_WALLETACCOUNT"),
        //   icon: <WalletOutlined />,
        // },
        {
          label: "Apply Charge",
          key: "2",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("APPLY_CHARGES_WALLETACCOUNT"),
          icon: <WalletOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Cash IN",
          key: "1",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("CASH_IN_WALLETACCOUNT"),
          icon: <DownloadOutlined />,
        },
        {
          label: "Cash OUT",
          key: "2",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("CASH_OUT_WALLETACCOUNT"),
          icon: <UploadOutlined />,
        },
        {
          label: "Add Sub Wallet",
          key: "3",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("ADD_SUBWALLET_WALLETACCOUNT"),
          icon: <WalletOutlined />,
        },
        {
          label: "Apply Charge",
          key: "4",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("APPLY_CHARGES_WALLETACCOUNT"),
          icon: <WalletOutlined />,
        },
        {
          label: "Transfer to Sub Wallet",
          key: "5",
          route: "/wallet-account-action",
          disabled: !BOM.HasPermission("TRANSFER_TO_SUBWALLETACCOUNT"),
          icon: <SendOutlined />,
        },
      ];
    default:
      return [];
  }
};
export const handleSubWalletAccountActionButtons = (contractDetail) => {
  const status = contractDetail?.savingsAccountData?.status?.value;
  const subStatusBlock = contractDetail?.savingsAccountData?.subStatus?.block;
  const subStatusNone = contractDetail?.savingsAccountData?.subStatus?.none;

  switch (status?.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve",
          key: "1",
          route: "/sub-wallet-account-action",
          disabled: !BOM.HasPermission("APPROVE_WALLETACCOUNT"),
          icon: <SafetyOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Activate",
          key: "1",
          route: "/sub-wallet-account-action",
          disabled: !BOM.HasPermission("ACTIVATE_WALLETACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Cash IN",
          key: "1",
          route: "/sub-wallet-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CASH_IN_WALLETACCOUNT"),
          icon: <DownloadOutlined />,
        },
        {
          label: "Cash OUT",
          key: "2",
          route: "/sub-wallet-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("CASH_OUT_WALLETACCOUNT"),
          icon: <UploadOutlined />,
        },

        {
          label: subStatusBlock ? "Unhold" : "Suspend",
          key: "3",
          route: subStatusBlock ? undefined : "/sub-wallet-account-action",
          disabled: subStatusBlock
            ? subStatusNone || !BOM.HasPermission("UNHOLD_SAVINGSACCOUNT")
            : subStatusBlock || !BOM.HasPermission("HOLD_SAVINGSACCOUNT"),
          icon: <HolderOutlined />,
        },
        {
          label: "Transfer to Parent Wallet",
          key: "4",
          route: "/sub-wallet-account-action",
          disabled:
            subStatusBlock || !BOM.HasPermission("TRANSFER_TO_WALLETACCOUNT"),
          icon: <SendOutlined />,
        },
        {
          label: "Transfer to Sub Wallet",
          key: "5",
          route: "/sub-wallet-account-action",
          disabled:
            subStatusBlock ||
            !BOM.HasPermission("TRANSFER_TO_SUBWALLETACCOUNT"),
          icon: <SendOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const accountStatus = {
  pending: "submitted and pending approval",
  approved: "approved",
  disabled: "disabled",
  active: "active",
  block: "block",
  withdrawnByApplicant: "withdrawn by applicant",
  rejected: "rejected",
  closed: "closed",
  prematureClosed: "Premature Closed",
  matured: "matured",
};

export const AmountFormat = ({ amount, labelName, currency, precision }) => {
  return (
    <Statistic
      title={`${labelName ? labelName : "-"} ( ${currency ? currency : "-"} )`}
      prefix={currency}
      value={amount ? amount : 0}
      precision={precision ? precision : 2}
    />
  );
};

export const isDebit = (transactionType) => {
  return (
    transactionType?.withdrawal === true ||
    transactionType?.feeDeduction === true ||
    transactionType?.overdraftInterest === true ||
    transactionType?.withholdTax === true
  );
};

export const getCurrencySymbol = (currencyCode, currencies = []) => {
  const fallbackSymbols = {
    NGN: "₦",
    CNY: "¥",
  };

  const found = currencies.find((item) => item.value === currencyCode);
  return found?.symbol || fallbackSymbols[currencyCode] || "";
};
